export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;
export const PATH_ASSETS = 'assets';

export const RESPONSE_STATUS_SUCCESS = 200;
export const RESPONSE_STATUS_UNAUTHORIZED = 401;
export const RESPONSE_STATUS_NOT_FOUND = 404;

export const ACTION_PROMISE = 'ACTION_PROMISE';
export const ACTION_MULTIPLE = 'ACTION_MULTIPLE';

export const PRE_LOADER_SHOW = 'PRE_LOADER_SHOW';
export const PRE_LOADER_HIDE = 'PRE_LOADER_HIDE';

export const SHOW_ERROR = 'SHOW_ERROR';

export const ALERT_HIDE = 'ALERT_HIDE';
export const ALERT_SUCCESS = 'ALERT_SUCCESS';
export const ALERT_ERROR = 'ALERT_ERROR';

export const LOGOUT = 'LOGOUT';
export const  STORAGE_KEY = 'playground';
export const USER_LOCALSTORAGE_KEY = 'user';
export const APP_PROPS_GET = 'GET_APP_PROPS';

//catalog
export const CATEGORY_FIND_ALL = 'FIND_ALL_CATEGORY';
export const CATEGORY_FIND_ONE = 'FIND_ONE_CATEGORY';
export const CATEGORY_SET = 'SET_CATEGORY';
export const CATEGORY_SET_DESCRIPTION = 'SET_CATEGORY_DESCRIPTION';
export const CATEGORY_NORMALISE = 'NORMALISE_CATEGORY';
export const CATEGORY_ITEM_FIND_REQUEST = 'FIND_CATEGORY_REQUEST';
export const CATEGORY_ITEMS_SET = 'SET_CATEGORY_ITEMS';
export const CATEGORY_SEARCH_ITEM = 'SEARCH_ITEM_IN_CATEGORY';

export const ITEM_FIND_ONE = 'FIND_ONE_ITEM';
export const ITEM_SET = 'SET_ITEM';

export const PRODUCT_FIND_ALL = 'FIND_ALL_PRODUCT';
export const PRODUCT_FIND_ONE = 'FIND_ONE_PRODUCT';

export const NEWS_FIND_ALL = 'FIND_ALL_NEWS';
export const NEWS_FIND_ONE = 'FIND_ONE_NEWS';

export const REVIEW_FIND_ALL = 'FIND_ALL_REVIEW';
export const REVIEW_FIND_ONE = 'FIND_ONE_REVIEW';

export const PROJECT_FIND_ALL = 'FIND_ALL_PROJECT';
export const PROJECT_FIND_ONE = 'FIND_ONE_PROJECT';

export const CITY_FIND_ALL = 'FIND_ALL_CITY';
export const CITY_FIND_ONE = 'FIND_ONE_CITY';

export const DEALER_FIND_ALL = 'FIND_ALL_DEALER';
export const DEALER_FIND_ONE = 'FIND_ONE_DEALER';

export const APP_SETTINGS_REQUEST = 'LOAD_APP_SETTINGS';
export const APP_CITY_SET_REQUEST = 'SET_APP_CITY_SETTING';
export const APP_SETTINGS_SET = 'SET_APP_SETTINGS';
export const APP_SETTING_CITY = 'city';

export const PAGE_LOADED = 'LOAD_PAGE';
export const PAGE_LOAD_REQUEST = 'REQUEST_LOAD_PAGE';
export const PAGE_SET = 'SET_PAGE_PROPS';

export const DEALER_REQUEST = 'SUBMIT_DEALER_FORM';
export const DEALER_REQUEST_RESULT = 'PREPARE_DEALER_FORM_RESPONSE';

//urls
export const URL_HOME = 'https://www.k-gorod.ru';
export const URL_AUTH = 'https://auth.k-gorod.ru:9443/constructor';
export const URL_LOGIN = '/user/sign-in/login';
export const URL_LOGOUT = 'auth/logout';
export const URL_APP_SETTINGS = 'site/settings';
export const URL_APP_SET_CITY_SETTING = 'site/city-set';
export const URL_APP_AUTH_URL = 'config';
export const URL_APP_USER_INFO = 'auth/user-info';

export const URL_PAGE_HOME = 'site/page';
export const URL_PAGE_NEWS = 'news/page';
export const URL_PAGE_NEWS_ONE = 'news/view';
export const URL_PAGE_NEWS_REVIEW = 'news/review';
export const URL_PAGE_PORTFOLIO = 'portfolio/page';
export const URL_PAGE_DEALER = 'dealer/page';
export const URL_PAGE_CONTACT = 'contact/page';
export const URL_DEALER_SUBMIT = 'dealer/submit';
export const URL_CONTACT_FORM_SUBMIT = 'contact/submit';

export const URL_CATEGORIES = 'category';
export const URL_CATEGORY = 'category/view';
export const URL_CATEGORY_CONTENT = 'category/page';
export const URL_CATEGORY_PARAM = 'category/param';
export const URL_CATEGORY_ITEMS = 'category/products';
export const URL_PRODUCT_GET = 'product/page';
export const URL_PRODUCT_IN_CONSTRUCT = process.env.REACT_APP_URL_PRODUCT_IN_CONSTRUCT;
export const URL_CONSTRUCT_SAVE_AS = 'save-as';
export const URL_CONSTRUCT_LOAD = 'load-scene';
export const URL_SEARCH = 'search';

export const CART_ADD_ITEM = 'ADD_ITEM_TO_CART';
export const CART_REMOVE_ITEM = 'REMOVE_ITEM_FROM_CART';
export const CART_LOAD_FROM_LOCAL_STORAGE = 'LOAD_CART_FROM_LOCAL_STORAGE';
export const CART_TO_LOCAL_STORAGE = 'SET_CART_TO_LOCAL_STORAGE';

export const TOP_VIEW_IMAGE_INDEX = 8;

/*export const IZO_TRANSFORM_A = 0.55;  //scale по горизонтали --- наклон по y
export const IZO_TRANSFORM_B = 0.64;  //на N пикселей вниз
export const IZO_TRANSFORM_C = 0.9;   //каждая следующая строчка будет смещена на N пиксель вправо, относительно предыдущей.
export const IZO_TRANSFORM_D = -0.35; //scale по вертикали --- наклон по x
*/
//200528 11:26 Рабочий вариант с точностью в три знака после запятой
//export const IZO_TRANSFORM_A = 0.544;  //3 scale по горизонтали --- наклон по y
//export const IZO_TRANSFORM_B = 0.636;  //1на N пикселей вниз
//export const IZO_TRANSFORM_C = 0.948;   //*каждая следующая строчка будет смещена на N пиксель вправо, относительно предыдущей.
//export const IZO_TRANSFORM_D = -0.365; //4 scale по вертикали --- наклон по x

export const IZO_TRANSFORM_A = 0.544 ;  //3 scale по горизонтали --- наклон по y
export const IZO_TRANSFORM_B = 0.636;  //1на N пикселей вниз
export const IZO_TRANSFORM_C = 0.948;   //*каждая следующая строчка будет смещена на N пиксель вправо, относительно предыдущей.
export const IZO_TRANSFORM_D = -0.365; //4 scale по вертикали --- наклон по x

/**
 export const IZO_TRANSFORM_A = 0.623;  //scale по горизонтали --- наклон по y
 export const IZO_TRANSFORM_B = 0.73;  //на N пикселей вниз
 export const IZO_TRANSFORM_C = 1.076;   //каждая следующая строчка будет смещена на N пиксель вправо, относительно предыдущей.
 export const IZO_TRANSFORM_D = -0.414; //scale по вертикали --- наклон по x
 */

/*export const IZO_TRANSFORM_A = -0.934;  //scale по горизонтали --- наклон по y
export const IZO_TRANSFORM_B = 0.358;  //на N пикселей вниз
export const IZO_TRANSFORM_C = -0.649;   //каждая следующая строчка будет смещена на N пиксель вправо, относительно предыдущей.
export const IZO_TRANSFORM_D = -0.761; //scale по вертикали --- наклон по x*/


//export const squareSize = 69.5; совпадает по x
// export const squareSize = 58.2;
export const squareSize = 66;
export const grassMod = 2.5;
